import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import ServicesPage from '../pages/services/page';
import PortfolioPage from '../pages/portfolio/page';
import SolucaoPage from '../pages/Solucao';
import EventosPage from '../pages/Eventos';
import BlogPage from '../pages/blog/page';
import BlogPostPage from '../pages/blog-post/page';
import BlogCategoryPage from '../pages/blog-category/page';
import ContactPage from '../pages/contact/page';
import FAQPage from '../pages/faq/page';
import NotFoundPage from '../pages/NotFound';
import PoliticaPrivacidadePage from '../pages/PoliticaPrivacidade';
import PoliticaCookiesPage from '../pages/PoliticaCookies';
import CityLandingPage from '../pages/city-landing/page';
import CidadesHubPage from '../pages/cidades/page';
import SaoPauloPage from '../pages/sp-landing/page';
import RioDeJaneiroPage from '../pages/rio-landing/page';
import BrasiliaPage from '../pages/brasilia-landing/page';
import BeloHorizontePage from '../pages/bh-landing/page';
import CuritibaPage from '../pages/cwb-landing/page';
import PortoAlegrePage from '../pages/city-landing/porto-alegre';
import RecifePage from '../pages/city-landing/recife';
import FortalezaPage from '../pages/city-landing/fortaleza';
import SalvadorPage from '../pages/city-landing/salvador';
import AracajuPage from '../pages/city-landing/aracaju';
import NatalPage from '../pages/city-landing/natal';
import CampinasPage from '../pages/city-landing/campinas';
import SjcPage from '../pages/city-landing/sao-jose-dos-campos';
import RibeiraoPretoPage from '../pages/city-landing/ribeirao-preto';
import SantosPage from '../pages/city-landing/santos';
import BarueriPage from '../pages/city-landing/barueri';
import SbcPage from '../pages/city-landing/sao-bernardo-do-campo';
import GuarulhosPage from '../pages/city-landing/guarulhos';
import JundiaiPage from '../pages/city-landing/jundiai';
import SpEstadoHubPage from '../pages/sp-estado/page';
import KnowledgeBasePage from '../pages/knowledge-base/page';
import PalestraSilenciosaEventosPage from '../pages/palestra-silenciosa-eventos/page';
import FestaSilenciosaPage from '../pages/festa-silenciosa/page';
import AulaSilenciosaPage from '../pages/aula-silenciosa/page';
import AluguelFonesPage from '../pages/aluguel-fones/page';
import AluguelFonesEstandePage from '../pages/aluguel-fones-estande/page';
import AtivacaoExperienciaPage from '../pages/ativacao-experiencia/page';
import OrcamentoPage from '../pages/orcamento/page';
import OrcamentoConfirmacaoPage from '../pages/orcamento/confirmacao/page';
import ComparativoHubPage from '../pages/comparativo/page';
import ComparisonPage from '../pages/comparativo/comparison/page';
import VenuesHubPage from '../pages/venues/page';
import VenuePage from '../pages/venues/venue/page';
import GuiaPalestraSilenciosaPage from '../pages/guia-palestra-silenciosa/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/sobre',
    element: <AboutPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/quem-somos',
    element: <AboutPage />,
  },
  {
    path: '/o-que-fazemos',
    element: <ServicesPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/servicos',
    element: <ServicesPage />,
  },
  {
    path: '/eventos',
    element: <EventosPage />,
  },
  {
    path: '/fones-sem-fio-aulas-spinning-academias',
    element: <SolucaoPage />,
  },
  {
    path: '/fones-sem-fio-aulas-danca-academias',
    element: <SolucaoPage />,
  },
  {
    path: '/fones-sem-fio-visita-tecnica',
    element: <SolucaoPage />,
  },
  {
    path: '/fones-sem-fio-visita-chao-de-fabrica',
    element: <SolucaoPage />,
  },
  {
    path: '/fones-sem-fio-feiras-agro-agropecuarias',
    element: <SolucaoPage />,
  },
  {
    path: '/fones-sem-fio-eventos-fitness-esportivos',
    element: <SolucaoPage />,
  },
  {
    path: '/fones-sem-fio-corridas-maratonas',
    element: <SolucaoPage />,
  },
  {
    path: '/fones-sem-fio-seminarios-congressos',
    element: <SolucaoPage />,
  },
  {
    path: '/fones-sem-fio-shows-eventos-ao-ar-livre',
    element: <SolucaoPage />,
  },
  {
    path: '/fones-sem-fio-grandes-eventos-mais-de-1000-participantes',
    element: <SolucaoPage />,
  },
  {
    path: '/fones-sem-fio-palestras-simultaneas',
    element: <SolucaoPage />,
  },
  {
    path: '/fones-sem-fio-palestras-mudas',
    element: <SolucaoPage />,
  },
  {
    path: '/portfolio',
    element: <PortfolioPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/categoria/:categorySlug',
    element: <BlogCategoryPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogPostPage />,
  },
  {
    path: '/contato',
    element: <ContactPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/perguntas-frequentes',
    element: <FAQPage />,
  },
  {
    path: '/cidades',
    element: <CidadesHubPage />,
  },
  {
    path: '/sao-paulo',
    element: <SaoPauloPage />,
  },
  {
    path: '/rio-de-janeiro',
    element: <RioDeJaneiroPage />,
  },
  {
    path: '/brasilia',
    element: <BrasiliaPage />,
  },
  {
    path: '/belo-horizonte',
    element: <BeloHorizontePage />,
  },
  {
    path: '/curitiba',
    element: <CuritibaPage />,
  },
  {
    path: '/porto-alegre',
    element: <PortoAlegrePage />,
  },
  {
    path: '/recife',
    element: <RecifePage />,
  },
  {
    path: '/fortaleza',
    element: <FortalezaPage />,
  },
  {
    path: '/salvador',
    element: <SalvadorPage />,
  },
  {
    path: '/aracaju',
    element: <AracajuPage />,
  },
  {
    path: '/natal',
    element: <NatalPage />,
  },
  {
    path: '/campinas',
    element: <CampinasPage />,
  },
  {
    path: '/sao-jose-dos-campos',
    element: <SjcPage />,
  },
  {
    path: '/ribeirao-preto',
    element: <RibeiraoPretoPage />,
  },
  {
    path: '/santos',
    element: <SantosPage />,
  },
  {
    path: '/barueri',
    element: <BarueriPage />,
  },
  {
    path: '/alphaville',
    element: <BarueriPage />,
  },
  {
    path: '/sao-bernardo-do-campo',
    element: <SbcPage />,
  },
  {
    path: '/guarulhos',
    element: <GuarulhosPage />,
  },
  {
    path: '/jundiai',
    element: <JundiaiPage />,
  },
  {
    path: '/sao-paulo-estado',
    element: <SpEstadoHubPage />,
  },
  {
    path: '/knowledge-base',
    element: <KnowledgeBasePage />,
  },
  {
    path: '/base-de-conhecimento',
    element: <KnowledgeBasePage />,
  },
  {
    path: '/palestra-silenciosa-eventos',
    element: <PalestraSilenciosaEventosPage />,
  },
  {
    path: '/festa-silenciosa',
    element: <FestaSilenciosaPage />,
  },
  {
    path: '/silent-disco',
    element: <FestaSilenciosaPage />,
  },
  {
    path: '/aula-silenciosa',
    element: <AulaSilenciosaPage />,
  },
  {
    path: '/silent-class',
    element: <AulaSilenciosaPage />,
  },
  {
    path: '/aluguel-fones-sem-fio',
    element: <AluguelFonesPage />,
  },
  {
    path: '/locacao-fones-sem-fio',
    element: <AluguelFonesPage />,
  },
    {
      path: '/aluguel-fones-estande-sao-paulo',
      element: <AluguelFonesEstandePage />,
    },
    {
      path: '/ativacao-de-experiencia-com-fones-sao-paulo',
      element: <AtivacaoExperienciaPage />,
    },
  {
    path: '/orcamento',
    element: <OrcamentoPage />,
  },
  {
    path: '/solicitar-orcamento',
    element: <OrcamentoPage />,
  },
  {
    path: '/orcamento/confirmacao',
    element: <OrcamentoConfirmacaoPage />,
  },
  {
    path: '/comparativo',
    element: <ComparativoHubPage />,
  },
  {
    path: '/comparativo/:slug',
    element: <ComparisonPage />,
  },
  {
    path: '/locais',
    element: <VenuesHubPage />,
  },
  {
    path: '/locais/:slug',
    element: <VenuePage />,
  },
  {
    path: '/guia-palestra-silenciosa',
    element: <GuiaPalestraSilenciosaPage />,
  },
  {
    path: '/politica-privacidade',
    element: <PoliticaPrivacidadePage />,
  },
  {
    path: '/politica-cookies',
    element: <PoliticaCookiesPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;